export const FUNDING_REVIEW_PATH = "/funding-review";

/**
 * The retired Verify SKU Loans pages, which the funding review replaced. App.tsx redirects
 * them here so a bookmark lands on the new screen instead of the catch-all's /login.
 */
export const FUNDING_REVIEW_REDIRECTS: string[] = ["/verify-sku-loans", "/verify-sku-loan-details"];
